<template>
  <div class="service-record">
    <ServiceRecordDates
      :service-date="serviceRecord.serviceDate"
      :next-service-date="serviceRecord.nextServiceDate"
    />
    <ServiceRecordDescription :description="serviceRecord.comment" />
    <ServiceRecordStatus
      :status="serviceRecord.serviceState || serviceRecord.status"
      :status-text="statusText"
      :can-update-status="true"
      @mark-complete="handleMarkComplete"
    />
    <div class="service-record__files">
      <ServiceRecordFiles
        :files="serviceRecord.attachments || []"
        :supplier-id="serviceRecord.supplierId"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ServiceRecordDates from "./components/ServiceRecordDates.vue";
import ServiceRecordDescription from "./components/ServiceRecordDescription.vue";
import ServiceRecordFiles from "./components/ServiceRecordFiles.vue";
import ServiceRecordStatus from "./components/ServiceRecordStatus.vue";
import type { ServiceRecord } from "@/types/service-records";

interface Props {
  serviceRecord: ServiceRecord;
}

interface Emits {
  (e: "mark-complete", recordId: number): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

// Computed function to get status text
const statusText = computed(() => {
  const status = props.serviceRecord.serviceState || props.serviceRecord.status;
  return status === "Completed" ? "Fullført" : "Pågående";
});

const handleMarkComplete = () => {
  emit("mark-complete", props.serviceRecord.id);
};
</script>

<style lang="scss" scoped>
.service-record {
  background-color: $color-primary-lighter;
  padding: 2.5rem;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media only screen and (max-width: $bp-sm) {
    padding: 1rem;
    margin: 0.5rem;
    gap: 24px;
  }
}
</style>
